<div @fadeInOutTrigger class="dimmer"></div>
